import { useContext, useState, useEffect, createContext } from "react";
import { toast } from "react-hot-toast";
import * as api from "../utils/api";

const SearchContext = createContext();

export function useSearch() {
  return useContext(SearchContext);
}

export function SearchProvider({ children }) {
  const [isLoading, setLoading] = useState(false);
  const [vendorTypes, setVendorTypes] = useState([]);
  const [banners, setBanners] = useState([]);
  const [allVendors, setVendors] = useState([]);
  const [activeVendor, setVendor] = useState();
  const [vendorTypeCategories, setvendorTypeCategories] = useState();
  const [products, setProducts] = useState();

  const get_vendor_types = async () => {
    try {
      const response = await api.get_vendor_types();
      setVendorTypes(response);
    } catch (error) {
      // toast.error("Failed to load vendor types");
    }
  };

  const get_banners = async () => {
    try {
      const response = await api.get_banners();
      setBanners(response.data);
    } catch (error) {
      // toast.error("Failed to load banners");
    }
  };

  const get_vendors = async (id) => {
    try {
      const response = await api.get_vendors();
      setVendors(response.data);
    } catch (error) {
      // toast.error("Failed to load vendors");
    }
  };

  const get_vendor_by_id = async (id) => {
    try {
      const response = await api.get_vendors_by_id(id); 
      return response;
    } catch (error) {
      // toast.error("Failed to load vendor");
    }
  };


   //   get_categories by vendor_type_id
   const get_categories_by_vendor_type = async () => {
    try {
      const response = await api.get_categories_by_vendor_type ();
      setvendorTypeCategories(response.data);
      return true;
    } catch (error) {
      // toast.error("Failed to load vendor type categories");
    }
  };

  //   get_categories by vendor_type_id

  const get_products = async () => {
    try {
      const response = await api.get_products ();
      
      setProducts(response.data);
      return response.data;
    } catch (error) {
      // toast.error("Failed to popular foods nearby");
    }
  };

  const get_products_for_vendor = async (vendorId) => {
    try {
      const response = await api.get_products_by_vendor_id (vendorId);
      
      setProducts(response.data);
      return response.data;
    } catch (error) {
      // toast.error("Failed to popular foods nearby");
    }
  };

  useEffect(() => {
    get_vendor_types();
    get_banners();
    get_vendors();
  }, []);

  const value = {
    vendorTypes,
    get_vendor_types,
    banners,
    get_banners,
    allVendors,
    get_vendors,
    vendorTypeCategories,
    get_categories_by_vendor_type,
    products,
    get_products,
    isLoading,
    setLoading,
    activeVendor,
    get_vendor_by_id,
    get_products_for_vendor
  };

  return (
    <SearchContext.Provider value={value}>
      {!isLoading && children}
    </SearchContext.Provider>
  );
}
